import { render, staticRenderFns } from "./DashboardHero12MonthsBillTotal.vue?vue&type=template&id=9bbdd2d8&"
import script from "./DashboardHero12MonthsBillTotal.vue?vue&type=script&lang=js&"
export * from "./DashboardHero12MonthsBillTotal.vue?vue&type=script&lang=js&"
import style0 from "./DashboardHero12MonthsBillTotal.vue?vue&type=style&index=0&id=9bbdd2d8&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports